module.exports = "<div class=\"row wrapper border-bottom white-bg page-heading\">\r\n  <div class=\"col-lg-10\">\r\n    <ol class=\"breadcrumb\">\r\n      <li>\r\n        <a>管理平台</a>\r\n      </li>\r\n      <li *ngFor=\"let r of routing\">\r\n        <a [routerLink]=\"(r.url==''||r.notLink)?[]:[r.url]\">{{r.name}}</a>\r\n      </li>\r\n    </ol>\r\n  </div>\r\n  <div class=\"col-lg-2\">\r\n\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index-heading/index-heading.component.html
// module id = ../../../../../ng-src/app/module/index-operation/index/index-heading/index-heading.component.html
// module chunks = main